export default "__VITE_PUBLIC_ASSET__af7c1342__"